import produce from 'immer';
import cloneDeep from 'lodash/cloneDeep';

import { createReducer } from 'utils/redux';

import type {
  CcmCampaignPaymentsAction,
  CcmCampaignPaymentsState
} from './types/CcmCampaignPaymentsRedux.type';

const INITIAL_STATE: CcmCampaignPaymentsState = {
  brandPayment: null,
  creatorPayouts: { type: 'initial', list: [] }
};

export default createReducer<CcmCampaignPaymentsState, CcmCampaignPaymentsAction>(
  'ccmCampaignPayments',
  cloneDeep(INITIAL_STATE),
  {
    'ccm-campaign-payments/brand-loaded': (state, { brandPayment }) => produce(state, draft => {
      draft.brandPayment = brandPayment;
    }),
    'ccm-campaign-payments/creator-payouts-loaded': (state, { creatorPayouts }) => produce(state, draft => {
      draft.creatorPayouts = { type: 'recieved', list: creatorPayouts };
    }),
    'ccm-campaign-payments/flush': (state) => produce(state, draft => {
      const emptyState = cloneDeep(INITIAL_STATE);

      Object.keys(emptyState).forEach(key => {
        draft[key] = emptyState[key];
      });
    })
  }
);
